import { CreateDrawerFormProps, FormDrawer, FormDrawerContent, FormDrawerContentProps } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { FileInputField } from "~root/payrolls/FileInputField";

export interface IPayrollCreateFormState {
	files: File[];
}

const useValidate = () => {
	const { t } = useTranslation();
	return (values: IPayrollCreateFormState) => {
		const errors: { [K in keyof IPayrollCreateFormState]?: any } = {};

		if (!values.files.length) {
			errors.files = t("Field is required");
		}
		return errors;
	};
};

const PayrollDrawerContent: FC<FormDrawerContentProps> = (props) => {
	const { t } = useTranslation();

	return (
		<FormDrawerContent {...props}>
			<FileInputField name="files" label={t("Files")} multiple />
		</FormDrawerContent>
	);
};

const initialValues: IPayrollCreateFormState = {
	files: [],
};

export const PayrollCreateDrawer: FC<CreateDrawerFormProps<IPayrollCreateFormState>> = (props) => {
	const { t } = useTranslation();
	const validate = useValidate();

	return (
		<FormDrawer
			{...props}
			validate={validate}
			title={t("Upload payrolls")}
			initialValues={initialValues}
			renderForm={(props) => <PayrollDrawerContent {...props} />}
		/>
	);
};
